import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1503cd78"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "components__rec-history-causes" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Folgende Vorstellungsanlässe wurden bereits bearbeitet:", -1))
const _hoisted_3 = ["href"]
const _hoisted_4 = { key: 1 }

import { themingCssClass } from "../../mixins/theming-mixin";
  import { recProps } from '../../mixins/rec-component';

  
export default /*#__PURE__*/_defineComponent({
  __name: 'rec-history-causes',
  props: {...recProps()},
  setup(__props) {

  

  const themingExamCssClass = (exam) => {
      if (!exam.active) return themingCssClass("normal");
      return null;
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    ((_ctx.description.causes || []).length > 0)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _hoisted_2,
          _createElementVNode("ul", null, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.description.causes, (cause) => {
              return (_openBlock(), _createElementBlock("li", {
                class: "cause-li",
                key: cause.key
              }, [
                _createTextVNode(_toDisplayString(cause.label) + ": ", 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(cause.exams, (exam, index) => {
                  return (_openBlock(), _createElementBlock("span", {
                    key: exam.key
                  }, [
                    _createElementVNode("a", {
                      class: _normalizeClass([themingExamCssClass(exam)]),
                      href: exam.target
                    }, _toDisplayString(exam.label), 11, _hoisted_3),
                    (index != cause.exams.length - 1)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createTextVNode(", ")
                        ], 64))
                      : _createCommentVNode("", true)
                  ]))
                }), 128))
              ]))
            }), 128))
          ])
        ], 64))
      : (_openBlock(), _createElementBlock("p", _hoisted_4, "Es wurden noch keine Vorstellungsanlässe bearbeitet."))
  ]))
}
}

})